var exports = {
  "kL": "MobileBottomNavSkeleton.module__container___bzVWWE",
  "pc": "MobileBottomNavSkeleton.module__navItem___bzVWWE",
  "hk": "MobileBottomNavSkeleton.module__navItemLabel___bzVWWE",
};

module.exports = exports;
